/**
 * 健康管理 API 服务
 */
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

function request(options) {
  const base = getApiBaseUrl();
  const token = localStorage.getItem('token');
  return axios({
    baseURL: base,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    },
    ...options
  }).then((res) => res.data);
}

export const checkAccess = () =>
  request({ method: 'GET', url: '/api/health/check' });
export const getProfile = () =>
  request({ method: 'GET', url: '/api/health/profile' });

export const updateProfile = (data) =>
  request({ method: 'PUT', url: '/api/health/profile', data });

export const getDailyRecords = (params) =>
  request({ method: 'GET', url: '/api/health/records', params });

export const getRecordByDate = (date) =>
  request({ method: 'GET', url: `/api/health/records/${date}` });

export const saveDailyRecord = (data) =>
  request({ method: 'PUT', url: '/api/health/records', data });

// 打卡活动
export const getActivities = () =>
  request({ method: 'GET', url: '/api/health/activities' });
export const getActivitiesInRange = (date) =>
  request({ method: 'GET', url: '/api/health/activities/in-range', params: { date } });
export const createActivity = (data) =>
  request({ method: 'POST', url: '/api/health/activities', data });
export const updateActivity = (id, data) =>
  request({ method: 'PUT', url: `/api/health/activities/${id}`, data });
export const deleteActivity = (id) =>
  request({ method: 'DELETE', url: `/api/health/activities/${id}` });
export const resetActivities = () =>
  request({ method: 'DELETE', url: '/api/health/activities/reset' });
export const getActivityCompletions = (params) =>
  request({ method: 'GET', url: '/api/health/activities/completions', params });
export const saveActivityCompletion = (data) =>
  request({ method: 'PUT', url: '/api/health/activities/completions', data });
